export enum ELineStyle {
  Solid = 'Solid',
  Dash = 'Dash',
}

export interface ILinearChartSeriesData {
  data: { x: string; y: number | null }[];
  name: string;
  relatedToOppositeYAxis?: boolean;
  unit?: string;
  onPointClick?: (payload: { x: number }) => void;
}

export interface ILinearChartOptionsBuilderData {
  highlightWeekends?: boolean;
  comparisonLineStyle?: ELineStyle;
  withOppositeYAxis?: boolean;
  yAxisTitle?: string;
  yAxisOppositeTitle?: string;
  mainSeries: ILinearChartSeriesData[];
  comparisonSeries?: ILinearChartSeriesData[];
}

export type TLinearChartProps = ILinearChartOptionsBuilderData & {
  title: string;
};

export type TTooltipOneSeriesData = Record<string, { value: number | null; unit: string }>;
